module.exports = __webpack_public_path__ + "static/media/helpfulhounds.aa8575ce.png";